import { FC } from "react";
import BuildingsTable from "./BuildingsTable/BuildingsTable";
import OrganizationForm from "./OrganizationForm/OrganizationForm";
import nsiOrgStore from "../../../store/nsiOrganizationsStore";
import { observer } from "mobx-react-lite";

const ExpandedContent: FC = observer(({ record: organization }) => {
  return (
    <>
      {organization.showEdit ? (
        <OrganizationForm
          organization={organization}
          closeForm={() => {
            organization.showEdit = false;
            nsiOrgStore.organizationRowKeys.remove(organization.id);
          }}
        />
      ) : (
        <BuildingsTable organization={organization} />
      )}
    </>
  );
});

export default ExpandedContent;
